import {
  LocalizedValue,
  LocalizedValueProps,
} from "@/shared/form/localized-value/localized-value";
import { useTranslations } from "use-intl";
import { useValidateProperties } from "@/shared/template-properties/model/use-validate-properties";
import { SHOW_HINT } from "@/modules/admin-panel/notification-templates/features/save-notification-template/constants/messages";
import { PropertyInput } from "@/shared/template-properties/ui/property-input";

export function NotificationTitleInput({
  properties,
  ...props
}: Omit<LocalizedValueProps, "render"> & {
  properties: string[];
}) {
  const t = useTranslations("TemplateForm");
  const validateParams = useValidateProperties({
    properties,
  });

  return (
    <LocalizedValue
      {...props}
      label={t("Title")}
      tooltip={t(SHOW_HINT)}
      rules={[validateParams]}
      render={({ placeholder }) => (
        <PropertyInput placeholder={placeholder} properties={properties} />
      )}
    />
  );
}
